import { AddEditUserComponent } from './components/add-edit-user/add-edit-user.component';
import { AmountFormFieldComponent } from './components/amount-form-field/amount-form-field.component';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { ChatComponent } from './components/chat/chat.component';
import { ChatQuestionsComponent } from './components/chat/chat-questions/chat-questions.component';
import { ChatUnavailableComponent } from './components/chat/chat-unavailable/chat-unavailable.component';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { DecimalNumberFormatDirective } from './directives/decimal-number-format.directive';
import { DocumentUploadComponent } from './components/document-upload/document-upload.component';
import { DowntimeMessageComponent } from './components/downtime-message/downtime-message.component';
import { DropdownSearchTableComponent } from './components/dropdown-search-table/dropdown-search-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputNumericDirective } from './directives/input-numeric.directive';
import { LoadingSkeletonComponent } from './components/loading-skeleton/loading-skeleton.component';
import { MarketingPillarsComponent } from './components/marketing-pillars/marketing-pillars.component';
import { MaskCaseNumberDirective } from './directives/mask-case-number.directive';
import { MaskInputDirective } from './directives/mask-input.directive';
import { MaskPhoneNumberDirective } from './directives/mask-phone-number.directive';
import { ModalComponent } from './components/modal/modal.component';
import { MpCardDetailsComponent } from './components/mp-card-details/mp-card-details.component';
import { MultiSelectDropdownComponent } from './components/multi-select-dropdown/multi-select-dropdown.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { OverflowMenuComponent } from './components/overflow-menu/overflow-menu.component';
import { OverflowTooltipDirective } from './directives/overflow-tooltip.directive';
import { OrchidFormControlDirective } from './directives/ods-form-control.directive';
import { PaginationComponent } from './components/pagination/pagination.component';
import { PdfEditorComponent } from './components/pdf-editor/pdf-editor.component';
import { PhoenixTableComponent } from './components/phoenix-table/phoenix-table.component';
import { PhoenixTableDateInputComponent } from './components/phoenix-table/phoenix-table-date-input/phoenix-table-date-input.component';
import { PhoenixTableDollarAmountInputComponent } from './components/phoenix-table/phoenix-table-dollar-amount-input/phoenix-table-dollar-amount-input.component';
import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { PolExpandableTableComponent } from './components/pol-expandable-table/pol-expandable-table.component';
import { PolLoaderComponent } from './components/pol-loader/pol-loader.component';
import { PreventArrowKeyFromTabDirective } from './directives/prevent-arrow-key-from-tab.directive';
import { ProviderSearchComponent } from './components/provider-search/provider-search.component';
import { ReloadPageLinkDirective } from './directives/reload-page-link.directive';
import { SafePipe } from './pipes/safe.pipe';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SearchControlsComponent } from './components/search-controls/search-controls.component';
import { SingleSelectDropdownComponent } from './components/single-select-dropdown/single-select-dropdown.component';
import { TableComponent, SubTableHeaderDirective, SubTableBodyDirective } from './components/table/table.component';
import { TimeFormatDirective } from './directives/time-format.directive';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { TooltipDirective } from './directives/tooltip-directive';
import { TrapFocusDirective } from './directives/trap-focus.directive';
import { TruncatePipe } from './pipes/tuncate.pipe';
import { ZipCodePipe } from './pipes/zip-code.pipe';

@NgModule({
  imports: [
    ChatQuestionsComponent,
    ChatUnavailableComponent,
    CommonModule,
    FormsModule,
    InputNumericDirective,
    NgxExtendedPdfViewerModule,
    ReactiveFormsModule,
    ScrollingModule,
  ],
  declarations: [
    PhoneNumberPipe,
    SafePipe,
    TruncatePipe,
    ZipCodePipe,
    PaginationComponent,
    TableComponent,
    AutoFocusDirective,
    TooltipDirective,
    TrapFocusDirective,
    MaskPhoneNumberDirective,
    OverflowTooltipDirective,
    MultiSelectDropdownComponent,
    AddEditUserComponent,
    OrchidFormControlDirective,
    SearchControlsComponent,
    MaskInputDirective,
    ReloadPageLinkDirective,
    TooltipComponent,
    SubTableHeaderDirective,
    SubTableBodyDirective,
    ProviderSearchComponent,
    LoadingSkeletonComponent,
    ModalComponent,
    DowntimeMessageComponent,
    OverflowMenuComponent,
    PolLoaderComponent,
    SingleSelectDropdownComponent,
    DatePickerComponent,
    PhoenixTableComponent,
    PdfEditorComponent,
    DocumentUploadComponent,
    MarketingPillarsComponent,
    MpCardDetailsComponent,
    MaskCaseNumberDirective,
    PreventArrowKeyFromTabDirective,
    ChatComponent,
    PolExpandableTableComponent,
    DecimalNumberFormatDirective,
    TimeFormatDirective,
    DropdownSearchTableComponent,
    AmountFormFieldComponent,
    PhoenixTableDateInputComponent,
    PhoenixTableDollarAmountInputComponent
  ],
  exports: [
    PhoneNumberPipe,
    SafePipe,
    TruncatePipe,
    ZipCodePipe,
    PaginationComponent,
    TableComponent,
    AutoFocusDirective,
    TooltipDirective,
    TrapFocusDirective,
    MaskPhoneNumberDirective,
    OverflowTooltipDirective,
    MultiSelectDropdownComponent,
    AddEditUserComponent,
    OrchidFormControlDirective,
    SearchControlsComponent,
    MaskInputDirective,
    ReloadPageLinkDirective,
    TooltipComponent,
    SubTableHeaderDirective,
    SubTableBodyDirective,
    ProviderSearchComponent,
    LoadingSkeletonComponent,
    ModalComponent,
    DowntimeMessageComponent,
    InputNumericDirective,
    OverflowMenuComponent,
    SingleSelectDropdownComponent,
    DatePickerComponent,
    PolLoaderComponent,
    PhoenixTableComponent,
    PdfEditorComponent,
    DocumentUploadComponent,
    MarketingPillarsComponent,
    MpCardDetailsComponent,
    MaskCaseNumberDirective,
    PreventArrowKeyFromTabDirective,
    ChatComponent,
    PolExpandableTableComponent,
    DecimalNumberFormatDirective,
    TimeFormatDirective,
    DropdownSearchTableComponent,
    AmountFormFieldComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
